import { Box, Button, Flex, Text } from "@chakra-ui/react";
import UTMLink from "@components/UTMLink";
import { DefiVaultPartnerships } from "@container/pages/defi/DefiItem";
import { DeFiRow } from "@container/pages/defi/type";
import useDefiData, { DEFI_FILTER_VARIANT } from "@hooks/useDefiData";

const DefiPartnerships = () => {
  const defiData = useDefiData({
    type: "vault",
    variant: DEFI_FILTER_VARIANT.VAULT_PARTNERSHIPS,
  }) as DeFiRow[];

  if (defiData?.length > 0) {
    return (
      <Flex
        flexDir="column"
        pt="4px"
        // paddingX={{ base: "1rem", xl: "1.5rem" }}
        borderRadius="24px"
        bg={"#EBF9F9"}
        textAlign="left"
        mb={5}
        width="100%"
      >
        <Flex justifyContent={"space-between"} borderBottom="1px solid #B6DFDF">
          <Flex
            align={"center"}
            padding="8px 24px"
            borderBottom="2px solid #075A5A"
          >
            <Text
              fontWeight="600"
              fontSize={{ base: "12px", xl: "14px" }}
              lineHeight="24px"
              textAlign={"center"}
            >
              DeFi partnerships
            </Text>
          </Flex>
          <Flex pl="12px" padding="8px 24px">
            <UTMLink key={"defi"} href={"/defi?asset=agETH"} isExternal={false}>
              <Button
                size="sm"
                color="#FFFFFF"
                bg="#3F6870"
                border={"1px solid #B6DFDF"}
                _hover={{ bg: "#3F6870" }}
                textTransform="uppercase"
                fontSize={10}
                px="6px"
                flex={{
                  base: 1,
                  md: "none",
                }}
              >
                View All
              </Button>
            </UTMLink>
          </Flex>
        </Flex>
        <Box padding={{ base: "1rem", xl: "24px 24px" }}>
          <Flex
            overflowX={"auto"}
            overflowY={"hidden"}
            gap="16px"
            alignItems="center"
            mr={{ base: "-16px", xl: 0 }}
            width="100%"
          >
            {defiData.slice(0, 3).map((item: DeFiRow, idx: number) => (
              <DefiVaultPartnerships key={`partn_${idx}`} row={item} />
            ))}
          </Flex>
        </Box>
      </Flex>
    );
  }
};

export default DefiPartnerships;
